import { SYSTEM_ALERT_ADMIN_ROUTES } from '@/constants/systemAlerts.js';
import FeatureMiddleware from '@/middleware/FeatureMiddleware.js';
import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';
import { canAuthorSystemAlerts, SYSTEM_ALERTS_AUTHORING_FEATURE } from '@/policies/SystemAlertsAuthoringPolicy.js';

/**
 * Create and edit page (the T10 editor). Both routes share this single import.
 */
const editorPage = () => import('@/pages/administration/system-alerts/SystemAlertEditor.vue');

const meta = {
    middleware: [GateKeeperMiddleware],
    ability: ({ gateKeeper }) => canAuthorSystemAlerts(gateKeeper.user),
};

export default [
    {
        path: SYSTEM_ALERT_ADMIN_ROUTES.index.path,
        name: SYSTEM_ALERT_ADMIN_ROUTES.index.name,
        component: () => import('@/pages/administration/system-alerts/SystemAlertsIndex.vue'),
        meta: { ...meta, title: 'System Alerts', dataTablePage: true },
        beforeEnter: FeatureMiddleware(SYSTEM_ALERTS_AUTHORING_FEATURE),
    },
    {
        path: SYSTEM_ALERT_ADMIN_ROUTES.create.path,
        name: SYSTEM_ALERT_ADMIN_ROUTES.create.name,
        component: editorPage,
        meta: { ...meta, title: 'Create System Alert' },
        beforeEnter: FeatureMiddleware(SYSTEM_ALERTS_AUTHORING_FEATURE),
    },
    {
        path: SYSTEM_ALERT_ADMIN_ROUTES.edit.path,
        name: SYSTEM_ALERT_ADMIN_ROUTES.edit.name,
        component: editorPage,
        meta: { ...meta, title: 'Edit System Alert' },
        beforeEnter: FeatureMiddleware(SYSTEM_ALERTS_AUTHORING_FEATURE),
    },
];
